import styled from '@emotion/styled'
import { calcRem } from '../../../../../__styling/style-functions/calc-rem'
import { colors } from '../../../../../__styling/settings/colors'
import { zIndex } from '../../../../../__styling/settings/z-index'
import { themedValue } from '../../../../../__styling/themed-value'
import {
    fluidTypography,
    transition,
} from '../../../../../__styling/style-mixins'
import { Theme } from '../../../../../__styling/themes'

export const StyledBreachDiscountContent = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    position: 'relative',
    zIndex: zIndex.common.regWall.box,
    fontFamily: theme.fonts.subscriber.text,
    color: colors.white,
    paddingTop: calcRem(theme.margins.lg),
    paddingBottom: calcRem(theme.margins.md),
    background: themedValue(theme, {
        thewest: colors.thewest.westblue,
        perthnow: colors.perthnow.greyBasalt90,
        sevennews: colors.sevennews.charade,
    }),
}))

export const StyledRegistrationInfo = styled('div')(({ theme }) => ({
    flexBasis: 250,
    flexGrow: 1,
    margin: calcRem(0, theme.margins.md),
}))

const fluidTitle = (theme: Theme) =>
    themedValue(theme, {
        sevennews: fluidTypography(0, 1000, 24, 30),
        perthnow: fluidTypography(0, 1020, 24, 30),
        thewest: fluidTypography(0, 1220, 34, 44),
    })

export const StyledTitle = styled('h2')(({ theme }) => ({
    position: 'relative',
    margin: calcRem(theme.margins.xl, 0, 0, 0),
    fontWeight: 700,
    lineHeight: 1.267,
    ...fluidTitle(theme),
}))

export const StyledMessage = styled('div')(({ theme }) => ({
    marginBottom: calcRem(theme.margins.lg),
    fontWeight: 700,
    lineHeight: 1.1,
    color: colors.thewest.greyDolphin,
    ...fluidTypography(0, 1220, 22, 26),

    p: {
        margin: 0,
    },
}))

export const StyledTerms = styled('p')(({ theme }) => ({
    color: colors.white,
    p: {
        margin: 0,
        fontSize: 11,
    },
}))

export const StyledPackage = styled('div')(({ theme }) => ({
    flexGrow: 1,
    flexBasis: 400,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-around',
    margin: calcRem(0, theme.margins.md),

    '@media screen and (max-width: 374px)': {
        flexWrap: 'wrap',

        'div:last-of-type': {
            marginLeft: 0,
        },
    },
}))

export const StyledButton = styled('button')(({ theme }) => ({
    display: 'inline-block',
    border: `1px solid ${colors.white}`,
    marginBottom: calcRem(theme.margins.md),
    padding: calcRem(theme.margins.xs, theme.margins.md),
    background: colors.white,
    color: colors.thewest.westblue,
    borderRadius: calcRem(2),
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 700,
    ...fluidTypography(0, 1220, 22, 24),
    textDecoration: 'none',
    textTransform: 'uppercase',
    cursor: 'pointer',
    ...transition({ properties: ['background', 'color'] }),

    '&:hover': {
        backgroundColor: colors.white,
        color: themedValue(theme, {
            thewest: colors.thewest.greyGorilla,
            perthnow: colors.perthnow.blueKyanite,
            sevennews: colors.sevennews.blueRibbon,
        }),
    },

    '&:focus': {
        backgroundColor: themedValue(theme, {
            thewest: colors.thewest.greyGorilla,
            perthnow: colors.perthnow.pinkThulite,
            sevennews: colors.sevennews.red,
        }),
        borderColor: themedValue(theme, {
            thewest: colors.thewest.greyGorilla,
            perthnow: colors.perthnow.pinkThulite,
            sevennews: colors.sevennews.red,
        }),
        color: 'currentColor',
        outline: 'none',
        textDecoration: 'underline',
    },
}))
